import getCookie from "../../util/getcookie";
import { setCookie } from "../../util/cookies";

export const ApckAccordion = {
    props: {
        title: String,
        collapsed: {
            type: Boolean,
            default: false,
        },
        titleIcon: {
            type: String,
            default: null,
        },
        handler: {
            type: Function,
        },
        name: {
            type: String,
            default: '',
        },
    },
    data: function () {
        return {
            isCollapsed: this.collapsed,
        };
    },
    methods: {
        // v :: Boolean
        updateCookie(v) {
            if (this.name) setCookie(this.name, v, { expires: 7 });
        },
        toggle: function (_event) {
            this.isCollapsed = !this.isCollapsed;
            this.$emit('toggle', this.isCollapsed);
            this.updateCookie(!this.isCollapsed);
        },
        open: function (_event) {
            this.isCollapsed = false;
            this.$emit('open', this.isCollapsed);
            this.updateCookie(!this.isCollapsed);
        },
        close: function (_event) {
            this.isCollapsed = true;
            this.$emit('close', this.isCollapsed);
            this.updateCookie(!this.isCollapsed);
        },
    },
    template: `
    <div
        v-bind:class="[
            !isCollapsed ? 'accordion-open' : '',
            'accordion'
        ]"
    >
        <div 
            v-on:click="toggle()"
            class="header"
        >
            <span class="title">
                <span v-if="titleIcon" v-bind:class="[titleIcon]"/> {{ title }}
            </span>

            <div class="accordion-toggle">
                <i v-if="isCollapsed" class="fa fa-angle-down"></i>
                <i v-else class="fa fa-angle-up"></i>
            </div>
        </div>

        <div class="inner" v-show="!isCollapsed">
            <slot></slot>
        </div>
    </div>
    `,
    created() {
        const r = this.name ? getCookie(this.name) : null;
        // only do this if `collapsed` isn't provided as a prop
        if (r !== null && !this.collapsed) this.isCollapsed = r === 'true' ? false : true;
    },
};
